import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Navigate, useParams} from 'react-router-dom';
import {IV_DOCUMENT_IMAGE_TYPES} from '@guestapp/sdk';
import {PATHS} from '../../../../Routes';
import {ANALYTIC_EVENTS, Analytics} from '../../../../analytics';
import {useFetchIVLottie} from 'hooks';
import {getDocumentType, useIVStore} from 'store/identityVerification';
import {getHelperTextKey} from 'pages/IdentityVerification/utils';
import Button from 'components/common/Button';
import {useIVRemoteSync} from 'hooks/iv/useIVRemoteSync';
import {ModalTwoButtonsWrapper} from 'styled/common';
import {BottomBlock, StyledLottieIVDocumentsAnimations, Text, Wrapper} from './styled';

const ParamTypes = Object.values(IV_DOCUMENT_IMAGE_TYPES);

function UploadingTypeView() {
  useIVRemoteSync();
  const {t} = useTranslation('identity-verification');
  const {type} = useParams<{type: IV_DOCUMENT_IMAGE_TYPES; intentId: string}>();
  const documentType = useIVStore(getDocumentType);
  const {animationData: ivLottieAnimation} = useFetchIVLottie({type});

  const Message = React.useMemo(() => {
    const textKey = getHelperTextKey(type, documentType?.two_sides);

    if (!textKey) {
      return null;
    }

    return <Trans i18nKey={textKey} />;
  }, [documentType?.two_sides, type]);

  if (!type || !ParamTypes.includes(type)) {
    return <Navigate to={IV_DOCUMENT_IMAGE_TYPES.front} />;
  }

  return (
    <Wrapper className="iv-upload-type-view">
      {Boolean(Message) && <Text className="iv-upload-type-view__text">{Message}</Text>}
      <StyledLottieIVDocumentsAnimations loop animationData={ivLottieAnimation} />
      <BottomBlock className="iv-upload-type-view__bottom">
        <ModalTwoButtonsWrapper className="iv-upload-type-view__buttons">
          <Button
            label={t('take_a_photo')}
            to={`../${PATHS.verification?.[type]}/take`}
            onClick={() => {
              Analytics.track(ANALYTIC_EVENTS.ivTakingPhoto, {side: type});
            }}
            outlined
          />
          <Button
            label={t('upload_file')}
            to={`../${PATHS.verification?.[type]}/upload`}
            onClick={() => {
              Analytics.track(ANALYTIC_EVENTS.ivUploadingPhoto, {side: type});
            }}
            outlined
          />
        </ModalTwoButtonsWrapper>
      </BottomBlock>
    </Wrapper>
  );
}

export {UploadingTypeView};
